import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BidsListPage from './pages/BidsListPage';
// BidDetailPage is now used within BidDetailLayout
/*import BidDetailPage from './pages/BidDetailPage';*/
import BidDetailLayout from './pages/BidDetailLayout';
import TakeoffsPage from '../Takeoffs/pages/TakeoffsPage';
// Drawing, edit, and list pages are now routed inside BidDetailLayout
/*import DocumentsPage from './pages/DocumentsPage';
import DrawingDetailPage from './pages/DrawingDetailPage';
import InlineEditorPage from './pages/InlineEditorPage';*/

const BidsModule = () => (
  <Routes>
    {/* List view */}
    <Route path="" element={<BidsListPage />} />
    {/* Takeoff drawings for a bid */}
    <Route path=":id/takeoffs" element={<TakeoffsPage />} />
    {/* Bid detail layout (Info / Drawings / Edit / View) */}
    <Route path=":id/*" element={<BidDetailLayout />} />
    {/* Fallback to list */}
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);

export default BidsModule;